<template>
  <div class="btn-wrap">
    <template v-if="course.course_type == 2">
      <a v-if="course.is_buy != 1" class="btn btn-primary btn-disabled-opacity">
        请先报名对应班级
      </a>
      <a v-else-if="!has_buy || !isValid" class="btn btn-primary btn-disabled-opacity">
        课程已过期
      </a>
    </template>
    <!-- 按钮文案三种后端控制情况 -->
    <template v-else-if="buttons.length > 0">
      <!-- "action_type": 1 // 0 ,不可点击 ，1 ，立即购买，2，去学习 -->
      <a v-if="buttons[buttons.length - 1].action_type === 1" @click="buy" class="btn btn-warning">
        {{ buttons[buttons.length - 1].button_text }}
      </a>
      <a
        v-else-if="buttons[buttons.length - 1].action_type === 0"
        class="btn btn-warning btn-disabled"
      >
        {{ buttons[buttons.length - 1].button_text }}
      </a>
      <a
        v-else-if="buttons[buttons.length - 1].action_type === 2"
        @click="goToStudy"
        class="btn btn-warning"
      >
        {{ buttons[buttons.length - 1].button_text }}
      </a>
    </template>
    <!--
      course_right
      1：未购买（展示立即购买按钮）
      2：已购买、无行课权益（展示已报名按钮）
      3：有行课权益（展示立即学习按钮）
    -->
    <!-- <a v-else-if="!has_buy && course.course_right === 1" @click="buy" class="btn btn-warning">
      立即购买
    </a>
    <a v-else-if="has_buy && course.course_right === 2" class="btn btn-warning btn-disabled">
      已报名
    </a>
    <a
      v-else-if="has_buy && isValid && course.course_right === 3"
      @click="goToStudy"
      class="btn btn-warning"
    >
      立即学习
    </a> -->
    <a
      v-else-if="has_buy && !isValid && course.spell_price == 0 && !isShowVipFree"
      class="btn btn-warning"
      @click="buy"
    >
      立即续报
    </a>
    <template v-else-if="course.status == 1">
      <div class="spell clearfix" v-if="course.spell_price > 0">
        <div class="btn-buy btn-buy-spell">
          <div class="price">
            <Currency class="spell-currency"></Currency>
            <span v-if="course.head_price">
              {{ course.head_price / 100 }}
            </span>
            <span v-else>{{ course.spell_price / 100 }}</span>
          </div>
          <div class="label">我要开团</div>
          <div class="spell-qr">
            <div class="header">手机扫码开团</div>
            <vue-qr :text="shareUrl" :size="200" class="qrcode"></vue-qr>
          </div>
        </div>
        <div v-if="isShowVipFree" class="btn btn-primary" @click="vipFree()">会员免费</div>
        <div v-else-if="course.is_allow_sold == 0" class="btn-buy" @click="buy">
          <div class="price">
            <Currency class="spell-currency"></Currency>
            <span>{{ course.price / 100 }}</span>
          </div>
          <div class="label">
            {{ has_buy && !isValid ? '立即续报' : '单独购买' }}
          </div>
        </div>
      </div>
      <div v-else-if="isShowVipFree" class="btn btn-primary" @click="vipFree()">会员免费</div>
      <a
        v-else
        class="btn btn-primary"
        :class="{
          'btn-disabled': course.is_sold_out || course.is_allow_sold == 1,
        }"
        @click="buy"
      >
        {{
          course.is_allow_sold == 1 ? '联系客服报名' : course.is_sold_out ? '已售罄' : '立即报名'
        }}
      </a>
    </template>
    <span v-if="course.sales_display_switch" class="sales_num">
      {{ course.sales_num + course.browse_base }}人已报名
    </span>
    <CourseShowPackage
      v-if="course.package_id > 0 && !(has_buy && isValid)"
      :course="course"
    ></CourseShowPackage>
  </div>
</template>
<script>
import VueQr from 'vue-qr';
import CourseShowPackage from './CourseShowPackage.vue';

export default {
  name: 'CourseShowBuy',
  components: { VueQr, CourseShowPackage },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    buttons: {
      type: Array,
      default: () => {
        return [];
      },
    },
    has_buy: {
      type: Boolean,
      default: false,
    },
    vip_guide: {
      type: String,
      default: '',
    },
  },
  computed: {
    shareUrl() {
      return (
        this.$store.state.commonSetting.h5_address +
        '/course_detail?id=' +
        this.course.id +
        '&share_source=pc'
      );
    },
    isValid() {
      return this.$services.CourseService.checkBuyValid(this.course);
    },
    // 是否需要显示会员免费按钮
    isShowVipFree() {
      if (this.$store.state.token && this.course.vipData.is_vip_course == 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    buy() {
      this.$emit('buy');
    },
    goToStudy() {
      this.$emit('goToStudy');
    },
    vipFree() {
      this.$emit('vipFree');
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.btn {
  padding: 12px 40px;
  background: $primary-color;
  border-radius: 20px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 16px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  &:hover {
    background: linear-gradient(90deg, $primary-color-8, $primary-color);
  }
}
.btn-disabled {
  color: #c5c8ce;
  background-color: #f7f7f7;
}

.btn-disabled {
  background: #bfbfbf;
  color: white;
  cursor: not-allowed;

  &:hover {
    background: #bfbfbf;
  }
}
.btn-disabled-opacity {
  opacity: 0.3;
}
.spell {
  display: flex;

  .btn-buy {
    width: 148px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid $primary-color;
    float: left;
    margin-right: 15px;
    box-sizing: border-box;
    padding: 5px;
    color: $primary-color;
    position: relative;
    cursor: pointer;
    text-align: center;

    &.btn-buy-spell {
      background: linear-gradient(90deg, rgba(255, 118, 52, 1), rgba(252, 86, 36, 1));
      .price,
      .label {
        color: white;
      }
      &:hover {
        background: linear-gradient(90deg, rgba(255, 129, 68, 1), rgba(253, 98, 50, 1));
      }
    }
    &:nth-child(2) {
      margin-right: 0;
    }

    &:hover {
      background: #fff1ed;
      .spell-qr {
        display: block;
      }
    }

    .price {
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 14px;
      display: block;
      margin-top: 0;

      img {
        width: auto;
        height: 12px;
        margin-right: 3px;
      }

      .spell-currency {
        height: 12px;
        width: auto;
      }
    }

    .label {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 18px;
    }
  }

  .spell-qr {
    position: absolute;
    width: 152px;
    z-index: 999;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px 7px 7px 7px;
    background-color: white;
    left: 0;
    top: 60px;
    display: none;

    .qrcode {
      line-height: 1;
    }

    .header {
      background: rgba(217, 217, 217, 1);
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(140, 140, 140, 1);
      line-height: 20px;
      padding: 16px 0 10px 0;
      border-radius: 10px 7px 0 0;
    }

    &::before {
      position: absolute;
      content: '';
      width: 0;
      height: 0;
      border: solid 8px transparent;
      border-bottom-color: rgba(217, 217, 217, 1);
      top: -16px;
      left: 34px;
    }

    ::v-deep {
      img {
        max-width: 100%;
        border-radius: 0 0 7px 7px;
        vertical-align: bottom;
      }
    }
  }
}

.sales_num {
  font-size: 14px;
  color: #666666;
  margin-left: 31px;
}
</style>
